import React from 'react';
import styles from './WowFooter.scss';
import classNames from 'classnames/bind';

const cx = classNames.bind(styles);

const Footer = () => {
  return (
    <footer className={cx('footer')}>
      <div>feedback plz thankyou thankyou.</div>
      <div>aliswell86@naver.com</div>
    </footer>
  );
};

export default Footer;